/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Modulo {
  /**
   * Return the remainder from integer division
   *
   * @public
   * @function f1.modulo
   * @param divisor the number to divide with
   * @param value the number to divide
   * @example
   *
   * ```ts
   * f1.modulo(3, 7) => 1
   * f1.modulo(3, 8) => 2
   * f1.modulo(3, 9) => 0
   * f1.modulo(3, 10) => 1
   * ```
   */
  (divisor: number, value: number): number;
  /**
   * {@link FnModuloValue}
   * @param divisor the number to divide with
   */
  (divisor: number): (value: number) => number;
}

/**
 * @see Modulo
 */
export default (divisor: number, value: number) => (value | 0) % (divisor | 1);
